import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Modal, Row, Switch, Tabs } from "antd";

import moment from "moment";

import { companiesService } from "./../../redux/services";

import {
	UIDrawerForm,
	UIFormSection,
	UISwitchField,
	UIUpload,
} from "./../../components";

import Employees from "./Employees";
import Adresses from "./Adresses";
import Contacts from "./Contacts";
import Atestados from "./Atestados";

const config = {
	externalName: "paciente",
};

const STEPS = [
	{ key: "general", label: "Informações gerais", icon: <i className="fal fa-clipboard-list" /> },
	{ key: "adresses", label: "Endereços", icon: <i className="fal fa-map-marker-alt" /> },
	{ key: "contacts", label: "Contatos", icon: <i className="fal fa-address-book" /> },
	{ key: "employees", label: "Funcionários", icon: <i className="fal fa-users" /> },
	{ key: "atestados", label: "Atestados de Software", icon: <i className="fal fa-file-certificate" /> },
];

class Show extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onClose: PropTypes.func.isRequired,
		external: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			uuid: 0,
			item: {},
			general_key: null,
			settings: null,
			displayParamsREPP: true,
			displayAppCompany: true,
			displayAppEmployee: true
		};
	}

	componentDidMount() {
		this.handleCheckCompanyHasAccessREPP();
	}

	onOpen = (uuid, key) => {
		this.setState({
			isLoading: true,
			uuid: uuid,
			item: {},
			general_key: key,
		});

		companiesService.show({ uuid })
			.then((response) => {
				let item = response.data.data;
				this.setState({
					settings: {
						app_funcionario: response.data.configuracao.app_funcionario,
						app_empresa: response.data.configuracao.app_empresa,
					},
					isLoading: false,
					item: item,
				}, () => {
					// Upload
					if (item.avatar) {
						this.upload.setFiles([
							{
								uuid: item.uuid,
								url: item.avatar,
								type: 'image/jpeg',
							}
						]);
					}

					// Load options
					this.tabEmployees && this.tabEmployees.init(item);
					this.tabAdresses && this.tabAdresses.init(item);
					this.tabContacts && this.tabContacts.init(item);
					this.tabAtestados && this.tabAtestados.init(item);
				});
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
					onOk: () => {
						// Force close
						return this.onClose();
					}
				});
			});
	};


	resetFields = () => {
		this.setState({
			item: {},
		});
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	handleCheckCompanyHasAccessREPP = () => {
		const companyData = JSON.parse(localStorage.getItem('@mainCompany'));

		this.setState({
			displayParamsREPP: !(!companyData?.app_empresa && !companyData?.app_funcionario),
			displayAppCompany: companyData?.app_empresa,
			displayAppEmployee: companyData?.app_funcionario
		});
	}

	render() {
		const { visible } = this.props;
		const { 
			isLoading, 
			item, 
			settings,
			displayParamsREPP,
			displayAppCompany,
			displayAppEmployee
		} = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={1100}
				onClose={this.onClose}
				isLoading={isLoading}
				showBtnSave={false}
				icon={<i className="fal fa-building" />}
				title="Visualizar Empresa"
				subtitle="Consulte as informações da empresa.">
				<Form layout="vertical">
					<Tabs defaultActiveKey={this.state.general_key != null ? this.state.general_key : "general"} >
						<Tabs.TabPane
							forceRender
							tab={<span className="tab-icon-label">{STEPS[0].icon} {STEPS[0].label}</span>}
							key="general"
						>
							<UIFormSection
								icon={<i className="fal fa-clipboard-list" />}
								title="Informações gerais"
								description="Dados principais da empresa."
							>
								<Row gutter={16}>
									<Col xs={24} sm={5}>
										<UIUpload
											ref={el => this.upload = el}
											label="Logo"
											disabled
										/>
									</Col>
									<Col xs={24} sm={5}>
										<Form.Item label="Empresa principal">
											<Switch disabled checked={item.cnpj_principal == 1 ? true : false} />
										</Form.Item>
									</Col>
									<Col xs={24} sm={14}>
										<Form.Item label="Nome">
											{item?.nome ?? "-"}
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={16}>
									<Col xs={24} sm={12}>
										<Form.Item label="Tipo de Pessoa">
											{item.tipo_pessoa ?? "-"}
										</Form.Item>
									</Col>
									<Col xs={24} sm={12}>
										<Form.Item label="CEI">
											{item.cei ?? "-"}
										</Form.Item>
									</Col>
								</Row>
								{item.tipo_pessoa == "Física" ? (
									<>
										<Row gutter={16}>
											<Col xs={24} sm={12}>
												<Form.Item label="RG">
													{item.rg ?? "-"}
												</Form.Item>
											</Col>
											<Col xs={24} sm={12}>
												<Form.Item label="CPF">
													{item.cpf ?? "-"}
												</Form.Item>
											</Col>
										</Row>
										<Row gutter={16}>
											<Col xs={24} sm={12}>
												<Form.Item label="Data de nascimento">
													{item.data_nascimento ? moment(item.data_nascimento).calendar() : "-"}
												</Form.Item>
											</Col>
											<Col xs={24} sm={12}>
												<Form.Item label="CAEPF">
													{item.caepf ?? "-"}
												</Form.Item>
											</Col>
										</Row>
									</>
								) : (
									<>
										<Row gutter={16}>
											<Col xs={24} sm={12}>
												<Form.Item label="CNPJ">
													{item.cnpj ?? "-"}
												</Form.Item>
											</Col>
											<Col xs={24} sm={12}>
												<Form.Item label="CNO">
													{item.cno ?? "-"}
												</Form.Item>
											</Col>
										</Row>
										<Row gutter={16}>
											<Col xs={24} sm={12}>
												<Form.Item label="Inscrição Estadual (IE)">
													{item.ie ?? "-"}
												</Form.Item>
											</Col>
											<Col xs={24} sm={12}>
												<Form.Item label="Inscrição Municipal (IM)">
													{item.im ?? "-"}
												</Form.Item>
											</Col>
										</Row>
									</>
								)}
								<Row gutter={16}>
									<Col sm={8}>
										<Form.Item label="Número da Folha">
											{item.numero_folha ?? "-"}
										</Form.Item>
									</Col>
									<Col sm={8}>
										<Form.Item label="Nome do Responsável">
											{item.nome_responsavel ?? "-"}
										</Form.Item>
									</Col>
									<Col sm={8}>
										<Form.Item label="Cargo do Responsável">
											{item.cargo_responsavel ?? "-"}
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={16}>
									<Col sm={8}>
										<Form.Item label="Dia de fechamento">
											{item.dia_fechamento_periodo ?? "-"}
										</Form.Item>
									</Col>
									<Col sm={8}>
										<Form.Item label="Criação">
											{item.created_at ? moment(item.created_at).calendar() : "-"}
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={16}>
									<Col xs={24} md={8}>
										<UISwitchField bordered title="Ativo" description="Empresa ativa no sistema.">
											<Switch disabled checked={item.ativo == 1 ? true : false} />
										</UISwitchField>
									</Col>
									{displayParamsREPP && (
										<>
											{settings && settings.app_empresa && displayAppCompany && (
												<Col xs={24} md={8}>
													<UISwitchField bordered title="Aplicativo da empresa" description="Disponibiliza acesso ao app para esta empresa.">
														<Switch disabled checked={item.app_empresa == 1 ? true : false} />
													</UISwitchField>
												</Col>
											)}
											{settings && settings.app_funcionario && displayAppEmployee && (
												<Col xs={24} md={8}>
													<UISwitchField bordered title="Aplicativo do funcionário" description="Disponibiliza acesso ao app para funcionários.">
														<Switch disabled checked={item.app_funcionario == 1 ? true : false} />
													</UISwitchField>
												</Col>
											)}
										</>
									)}
								</Row>
							</UIFormSection>
						</Tabs.TabPane>
						<Tabs.TabPane
							forceRender
							tab={<span className="tab-icon-label">{STEPS[1].icon} {STEPS[1].label}</span>}
							key="adresses"
						>
							<Adresses
								ref={el => this.tabAdresses = el}
								readOnly
							/>
						</Tabs.TabPane>
						<Tabs.TabPane
							forceRender
							tab={<span className="tab-icon-label">{STEPS[2].icon} {STEPS[2].label}</span>}
							key="contacts"
						>
							<Contacts
								ref={el => this.tabContacts = el}
								readOnly
							/>
						</Tabs.TabPane>
						<Tabs.TabPane
							forceRender
							tab={<span className="tab-icon-label">{STEPS[3].icon} {STEPS[3].label}</span>}
							key="employees"
						>
							<Employees
								ref={el => this.tabEmployees = el}
							/>
						</Tabs.TabPane>
						<Tabs.TabPane
							forceRender
							tab={<span className="tab-icon-label">{STEPS[4].icon} {STEPS[4].label}</span>}
							key="atestados"
						>
							<Atestados ref={el => this.tabAtestados = el} />
						</Tabs.TabPane>

					</Tabs>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Show;
